export default {
    tms: {

    },
    generic: {
        Home: "ホーム",
        ReporMaster: "Report Master",
        GenericName: "Generic Name",
        ModuleCode: "モジュールコード",
        Description: "説明",
        FunctionCode: "機能コード",
        PageTitleCode: "ページタイトルコード",
        IsPaging: "ページング有無",
        IgnoreCount: "前のページ/次のページ",
        Creator: "作成者",
        CreateDate: "作成日",
        Modifier: "更新者",
        ModifyDate: "更新日",
        GMCUID: "GMC UID",
        SCHEMAUID: "SCHEMA UID",
        UIAction: "UI Action",
        Validation: "検証",
        Editable: "編集可能",
        Searchable: "検索可能",
        DefaultValue: "デフォルト値",
        Madatory: "必須",
        Displayable: "表示可能",
        Sequence: "シーケンス",
        Condition: "条件",
        Mandatory: "必須",
        AndOr: "かつ/または",
        GCDUID: "GCD UID",
        ParentGCDUID: "親 GCD UID",
        IfOrNotMove: "在庫移動操作が必要ですか？",
        TableName: "テーブル名",
        EnglishName: "英語名",
        CnName: "中国語名",
        TraditionalCNName: "繁体中国語名",
        KorName: "韓国語名",
        thName: "タイ語",
        jpName: "日本语",
        Header: "主要情報",
        TableAlias: "テーブルエイリアス",
        FieldName: "フィールド名",
        FieldType: "フィールドタイプ",
        FieldLength: "フィールド長",
        FieldLengthDecimal: "フィールド長（小数点以下）",
        ForeignTable: "Foreign テーブル",
        ForeignFIELD: "Foreign フィールド",
        LanguageCode: "言語コード",
        Module: "モジュール",
        SubPage: "サブページ",
        SubModule: "サブモジュール",
        Function: "機能",
        PageTitle: "ページタイトル",
        Decimal: "小数点以下",
        Edit: "編集",
        Add: "追加",
        More: "詳細",
        AreyoudeleTask: "選択したレコードを削除してもよろしいですか？",
        Yes: "はい",
        No: "いいえ",
        Delete: "削除",
        Zip: "Zip圧縮",
        Up: "上",
        Down: "下",
        Store: "保存",
        ButtonGroupName: "ボタングループ名",
        Apply: "適用",
        Configuration: "設定",
        Name: "名前",
        RenderType: "レンダリングタイプ",
        Type: "タイプ",
        Code: "コード",
        ViewType: "表示タイプ",
        PatternType: "パターンタイプ",
        ExtenalAPI: "外部 API",
        MapToModule: "モジュールマッピング",
        FieldMap: "フィールドマッピング",
        BehaviorPattern: "動作パターン",
        Parameters: "パラメータ",
        CustPage: "CustPage",
        Action: "アクション",
        Width: "幅",
        ConsParameter: "制約パラメータ",
        Constrainttable: "制約テーブル",
        Seq: "シーケンス",
        ValidationSQL: "検証SQL",
        operate: "操作",
        Group: "グループ",
        FKTable: "外部キーテーブル",
        FKFieldName: "外部キー名",
        SQLParameters: "SQL パラメータ",
        defaultValue: "デフォルト値",
        DisplayColumns: "表示列",
        SortSeq: "ソート順",
        OrderBy: "並び順",
        Refresh: "更新",
        PagePropertyGroupName: "ページプロパティグループ名",
        Disaplyable: "表示可能",
        Like: "曖昧",
        IsShowTitle: "タイトル表示",
        ShowTitleSeq: "タイトル表示順",
        OptionType: "選択タイプ",
        ExtentionValue: "拡張値",
        GenIdtype: "Gen Id type",
        Hyperlink: "ハイパーリンク",
        Isitunique: "一意性",
        Statistics: "統計",
        DataFormat: "データ形式",
        FieldPattern: "フィールドパターン",
        GenericParameters: "設定パラメータ",
        DefaultSelected: "デフォルト選択",
        IsReserveAdmin: "管理者として予約済み",
        TitleInfo: "タイトル情報",
        UniqueParameter: "一意パラメータ",
        Depend: "依存",
        IsDefType: "IsDefType",
        ConfigurationMethod: "設定の計算方法",
        CalcParameters: "計算パラメータ",
        CalcType: "計算タイプ",
        SurfixParameter: "サフィックスパラメータ",
        ComputationalEvent: "計算イベント",
        TriggerFields: "トリガーフィールド",
        IsTrigger: "トリガーであるか",
        Publish: "公開",
        AdvanceSearch: "高度な検索",
        SearchTemplate: "検索テンプレート",
        IsDefault: "デフォルトであるか",
        Loadable: "ロード可能",
        IsExtra: "追加であるか",
        ExtraParameters: "追加パラメータ",
        TemplateName: "テンプレート名",
        CreateTime: "作成時間",
        Copy: "コピー",
        CreateGenericData: "基本データを新規作成",
        AppendGenericData: "基本データを追加",
        DeleteGenericData: "基本データを削除",
        PleasemoduleonlyGeneric: "1つのモジュールにつき1つの基本データのみが有効であることを確認してください",
        DBSchema: "DB Schema",
        PageProperty: "ページプロパティ",
        SQL: "SQL",
        ConfigSQL: "SQL設定",
        Behavior: "動作",
        ForOption: "オプション",
        StartupModule: "起動モジュール",
        UseViewSQL: "ビューSQLを使用",
        ReportView: "レポートビュー",
        TableViewName: "テーブル/ビュー名",
        FiledName: "フィールド名",
        Basic: "基本",
        AliasName: "エイリアス名",
        SubModuleCode: "サブモジュールコード",
        SubModuleName: "サブモジュール名",
        FunctionName: "機能名",
        FunctionLevel: "機能レベル",
        ParentFunctionCode: "親機能コード",
        FunctionSeq: "機能シーケンス番号",
        FunctionURL: "機能URL",
        LangCode: "言語",
        Menu: "メニュー",
        GenericMenu: "Generic メニュー",
        RelationTable: "関連テーブル",
        UserMenu: "ユーザーメニュー",
        FunctionAPI: "機能 API",
        Status: "ステータス",
        NotInactive: "既に公開済みまたは無効な設定は公開できません",
        Mapto: "マッピング先",
        Project: "プロジェクト",
        Usage: "用途",
        Source: "ソース",
        TargetTo: "ターゲットカートン",
        ExcelType: "Excel タイプ",
        OnlyAllowLetter: "文字のみ入力可能です",
        Export: "エクスポート",
        SourceMap: "ソースマップ",
        MapToView: "ビューにマッピング",
        TargetMap: "ターゲットマップ",
        Excel: "Excel",
        SelectedMatched: "選択された列は一致する必要があります。",
        DataDuplication: "データ重複",
        UnUploadFile: "ファイルをアップロードしてください！",
        isShowCopy: "コピー",
        copySuccess: "コピー成功",
        totalOf: "合計 ",
        Records: "件のレコード"

    },
    userlang: {
        Address1: "住所1",
        Address2: "住所2",
        Address3: "住所3",
        Address4: "住所4",
        Postal: "郵便番号",
        Street: "通り",
        District: "区",
        Latitude: "緯度",
        Longitude: "経度",
        Country: "国",
        Enable: "有効",
        Disable: "無効",
        Empower: "権限付与",
        Edit: "編集",
        EditUser: "ユーザー編集",
        UserAccount: "ユーザーアカウント",
        LoginAccount: "ユーザーアカウント",
        DispName: "ユーザー名",
        Email: "メールアドレス",
        EmailInfoFrom: "入力されたメールアドレスは無効です！",
        FirstName: "名",
        MiddleName: "ミドルネーム",
        LastName: "姓",
        DisplayName: "表示名",
        Title: "敬称",
        Gender: "性別",
        Male: "男性",
        Female: "女性",
        Company: "会社",
        Department: "部署",
        Position: "役職",
        Telephone: "電話番号",
        City: "都市",
        SelectCity: "都市を選択してください",
        TimeZone: "タイムゾーン",
        english: "英語",
        englishName: "英語名",
        sumplifiedName: "簡体字中国語名",
        traditionalName: "繁体字中国語名",
        koreanName: "韓国語名",
        japaneseName:"日本語の名前",
        thaiName:"タイ語の名前",
        Language: "言語",
        Jtlang: "簡体字中国語",
        korlang: "韓国語",
        thlang: "ภาษาไทย",
        jplang: "日本語",
        ftlang: "繁体字中国語",
        Orgnization: "組織",
        Project: "プロジェクト",
        Delete: "削除",
        NorecordFound: "レコードが見つかりませんでした",
        Organization: "組織",
        Warehouse: "倉庫",
        Address: "住所",
        Save: "保存",
        AccessRights: "アクセス権",
        Pleaseselect: "選択してください",
        Role: "役割",
        PleaseOneleast: "少なくとも1つのレコードを選択してください。",
        SaveSuccessfully: "保存成功",
        AddProject: "プロジェクトを追加",
        AddWarehouse: "倉庫を追加",
        defaultOrg:"デフォルトの組織",
        defaultProj:"デフォルトの項目",
        domain:"ドメイン",
        useredQr:"ユーザーQR"
    },
    convertCountResult: {
        title: "棚卸結果変換",
        filenameStartFrom: "ファイル名の開始文字",
        importSuccess: "アップロード成功",
        pleaseUpload: "ファイルをアップロードしてください",
        noFileToDownload: "ダウンロード可能なファイルがありません",
        invalidFilename: "ファイル名の開始文字は2、S、Qのいずれかを指定してください",
        invalidFileType: ".xlsx形式のファイルのみアップロードできます"
    },
    publicLang: {
        DeleteSuccess: "削除成功",
        HelpMessage: "ヘルプ",
        PreviousPage: "前のページ",
        NextPage: "次のページ",
        Page: "ページ",
        CourierNumberIsNotNull: "配送伝票番号は空にできません",
        CourierNumber: "配送伝票番号",
        InputRequiredValue: "まず必須項目を入力してください！",
        containerIdNotExists: "コンテナIDが存在しないか、すでに受領済みです",
        CartonIdNumNotExists: "カートンIDが存在しないか、すでに受領済みです",
        PleaseOneLeast: "少なくとも1つのレコードを選択してください。",
        AreUpadte: "選択したレコードを更新しますか？",
        NotAllowtodeleteCancel: "削除/キャンセルは許可されていません",
        Notprintfirst: "印刷は許可されていません。まず割り当てを行ってください。",
        Notprintpackfirst: "印刷は許可されていません。まず梱包スキャンを行ってください。",
        ProjectandWarehouse: "プロジェクトと倉庫",
        AlertMessage: "アラートメッセージ",
        NewTemplateName: "新しいテンプレート名",
        ProjectTemplate: "プロジェクトテンプレート",
        StyleSetting: "スタイル設定",
        NavigationMode: "ナビゲーションモード",
        LeftLayout: "左側メニューレイアウト",
        TopLayout: "上部メニューレイアウト",
        Arecancel: "削除してもよろしいですか？",
        Areconfirm: "提出してもよろしいですか？",
        Yes: "はい",
        No: "いいえ",
        SKUSearch: "SKU検索",
        StatusNotNew: "注文ステータスは新規ステータスにできません",
        PubOk: "OK",
        theIstAdministrator: "現在のユーザーにはまだ権限が割り当てられていません。管理者に連絡してください。",
        PleaseSltAtleast: "少なくとも1つのレコードを選択してください。",
        ColumnSearchRequired: "データを読み込む前に、少なくとも1件の検索条件を設定してください。",
        PleaseCheckDisplayableFirst: "まず表示可能な内容をチェックしてください！",
        pleaseOneOnly: "1つのレコードのみを選択してください。",
        SelectRestrict: "選択できるデータ行数は100行を超えてはなりません",
        PleaseFirst: "1つのレコードを選択してください。",
        DraglistSort: "リストをドラッグして並べ替えます",
        CreatTime: "作成時間",
        Clear: "クリア",
        Save: "保存",
        UpdateSuccess: "更新成功",
        PasswordUpdatedSuccessfully:"パスワードが正常に更新されました!",
        Project: "プロジェクト",
        PleaseSelect: "選択してください",
        Required: "必須",
        ThenotEmail: "入力されたメールアドレスは無効です",
        PleaseEnter: "入力してください",
        PleaseMobileNumberCorrectly: "正しい電話番号を入力してください",
        RequireNumerFormat: "数字形式で入力してください",
        SystemAdministrator: "システム設定エラーです。管理者に連絡してください。",
        Download: "ダウンロード",
        Preview: "プレビュー",
        Wrongconfiguration: "設定エラー",
        NotAllowToOverReceive: "過剰受領は許可されていません",
        Search: "検索",
        Close: "閉じる",
        sendEdi: "EDI送信",
        rePrint: "再印刷",
        Cancel: "キャンセル",
        Confirm: "確認",
        CheckComplete: "確認完了",
        CancelCheckComplete: "確認完了をキャンセル",
        Template: "テンプレート",
        Loading: "積載",
        notExistScanInList: "{0} は入庫スキャンリストに存在しません",
        prompt: "プロンプト",
        closePrompt: "注文を閉じてもよろしいですか？",
        cancelPrompt: "注文のキャンセルを確認しますか？この操作は元に戻せません。",
        IncorrectConfiguration: "設定エラー",
        NoreportFound: "レポートが見つかりませんでした",
        PleaseinputEmail: "メールアドレスを入力してください！",
        Upload: "アップロード",
        UploadPhoto: "画像をアップロード",
        UploadSuccess: "アップロード成功！",
        DownloadCenter: "ダウンロードセンター",
        FileName: "ファイル名",
        Action: "機能",
        overScanMsg: "{0} は過剰受領を許可されていません",
        overRemoveMsg: "{0} は過剰削除を許可されていません",
        locationIsNull: "ロケーションは空にできません",
        ConfirmShipment: "出荷を確定しますか？",
        LastSKUCheckCompletePrompt: "注文の梱包が完了しました。確認してください。",
        statusError: "{0} ステータスエラー",
        waveIdIsNotEmpty: "{0} 注文にはすでに波次番号が存在します",
        UploadFileOverSize: "アップロードされたファイルがサイズ制限を超えています。確認してください。",
        UploadFailed: "アップロードに失敗しました",
        DownloadFailed: "ダウンロードに失敗しました",
        cardNeedReplace: "カードの交換が必要です",
        NoPickedStockInContainer: "このコンテナにはピッキングされた在庫がありません！",
        needToHangGooseDownGoldMedal: "ガチョウのダウンの金メダルを掛ける必要があります"

    },
    roleGe: {
        RoleLevel: "役割レベル",
        ModuleName: "モジュール名",
        SubModuleName: "サブモジュール名",
        Add: "追加",
        Delete: "削除",
        Edit: "編集",
        EditRole: "役割を編集",
        CreateRole: "役割を新規作成",
        RoleName: "役割名",
        RoleType: "役割タイプ",
        PleaseSelect: "選択してください",
        Description: "説明",
        Save: "保存",
        pleaseOneOnly: "1つのレコードのみを選択してください",
        SaveuSccessfully: "保存成功",
        RuleType: "ルールタイプ",
        RuleName: "ルール名",
        Organization: "組織",
        Project: "プロジェクト",
        Search: "検索",
        Creator: "作成者",
        CreateTime: "作成時間",
        Modifier: "更新者",
        ModifiyTime: "更新時間",
        Next: "次へ",
        SortSubmit: "順序提出",
        Inventory: "在庫",
        TableName: "テーブル名",
        FieldName: "フィールド名",
        InventoryFieldName: "在庫フィールド名",
        FieldType: "フィールドタイプ",
        Condition: "条件",
        CustomizeValue: "カスタム値",
        OrderBy: "並び順",
        Operation: "操作",
        SO: "注文",
        Rule: "ルール",
        Grouping: "グループ化",
        GroupingAndOrderBy: "グループ化と並び順",
        ReportSetting: "レポート設定",
        Import: "インポート",
        Lookup: "検索",
        ReportName: "レポート名",
        ConfigEnableUser: "利用可能なユーザーを設定"

    },
    menu: {
        NotificationList: "通知リスト",
        Read: "既読",
        Unread: "未読",
        ViewMore: "さらに表示",
        YouhaveViewedNotifications: "すべての通知リストを表示しました。",
        Receiver: "受信者",
        ReadTime: "閲覧可能時間",
        Status: "ステータス",
        Subject: "件名",
        RefType: "参照番号タイプ",
        RefNum: "参照番号",
        StartTime: "開始時間",
        CompleteTime: "完了時間",
        FirstName: "名",
        LastName: "姓",
        DisplayName: "表示名",
        MiddleName: "ミドルネーム",
        Email: "メールアドレス",
        Title: "敬称",
        Gender: "性別",
        Male: "男性",
        Female: "女性",
        Department: "部署",
        Position: "役職",
        Telephone: "電話番号",
        City: "都市",
        TimeZone: "タイムゾーン",
        DefaultLanguage: "デフォルト言語",
        PerformanceFeedback: "パフォーマンスフィードバック",
        SimulateUser: "ユーザーをシミュレート",
        ReleaseUser: "ユーザーをリリース",
        PrintNode: "印刷ノード",
        Logout: "ログアウト",
        NoRecordfound: "レコードが見つかりませんでした"

    },
    easyCron: {
        Specify: "指定",
        NoSet: "設定なし",
        OnlyDaysWeeksSet: "曜日と週のうち1つだけ設定できます",
        Perday: "毎日",
        Between: "間",
        Day: "日",
        to: "から",
        PreHour: "毎時",
        Hour: "時間",
        From: "から",
        PerMinute: "毎分",
        Minute: "分",
        PerYear: "毎年",
        Year: "年",
        Start: "開始",
        Expire: "期限",
        dayWeekNoset: "日または週を定義してください"

    },
    pubGicSet: {
        EachGroupRow: "注文ごとの行数",
        SplitRec: "受取書の分割",
        SelectSKU: "SKUを選択",
        SelectOneSKU: "SKUを1つ選択してください",
        QuantityTypeError: "スキャン数量のタイプエラー",
        soQty: "注文数量",
        OrderType: "注文タイプ",
        SelectFieldName: "フィールド名を選択",
        SkuDesc: "商品説明",
        WarehouseCode: "倉庫コード",
        NoRecordfound: "レコードが見つかりませんでした！",
        DragTheListTosort: "リストをドラッグして並べ替えます",
        AdvanceSearch: "高度な検索",
        AdvanceSort: "高度な並べ替え",
        FreezeCol: "列を固定",
        Clear: "クリア",
        Sort: "並べ替え",
        Search: "検索",
        FieldName: "フィールド名",
        OrderBy: "並び順",
        Name: "名前",
        PleaseName: "名前を入力してください",
        SearchTemplate: "テンプレートを検索",
        AdvanceSearcheTemplate: "高度な検索テンプレート",
        AreyoudeleTask: "選択したレコードを削除してもよろしいですか？",
        UserResetChanges: "以下の操作により、このユーザーが変更した権限がクリアされます。続行してもよろしいですか？",
        ResetPasswordsConfirm: "パスワードはNULLにリセットされます。続行しますか？",
        ResetPasswordsButton: "パスワードをリセット",
        InvalidSKU: "SKU {0} は無効です。",
        CartonClose: "{0} は箱詰め済みです。",
        UnpackedErrorWithEmptyCarton: "{0} 空箱はこれ以上キャンセルできません。",
        NotAllowOverPack: "{0} は過剰梱包を許可されていません。",
        ScanPackDecodeError: "スキャンバーコード形式エラー。",
        NotEnoughSkuRemoved: "箱に十分な {0} の数量がありません。",
        Yes: "はい",
        No: "いいえ",
        delete: "削除",
        PleaseTamplateNameFirst: "まずテンプレート名を選択してください",
        SaveSuccess: "保存成功",
        Mandatory: "必須",
        Pleaseselect: "選択してください",
        SelectPicture: "画像を選択してください",
        Split: "分割",
        FromValue: "From値",
        ToValue: "To値",
        NotAllowToSplit: "分割は許可されていません",
        PleaseSelectFieldName: "フィールド名を選択してください",
        FieldAddedRepeatedly: "フィールド名は重複して追加できません",
        ToLocationRequired: "目標ロケーションは必須です",
        QtyRequired: "数量は必須です",
        qtyTolocatioRequired: "目標ロケーションの数量は必須です",
        PleaseCheckTheData: "データを確認してください",
        ToValueCannotBeEmpty: "To値は空にできません",
        RecQty: "受領数量",
        Location: "ロケーション",
        ToLocation: "目標ロケーション",
        LocationISrequired: "ロケーションは必須です",
        NewContainer: "新しいコンテナ",
        LoadedCartonQty: "積載済みカートン数量",
        ContainerNo: "積載番号",
        SSCC: "カートン番号/配送伝票番号",
        trackingNo: "配送伝票番号",
        SSCC1: "カートン番号",
        lockUpSSCC: "カートン番号をロック",
        AmrContainerNo: "AMRコンテナ番号",
        iWmsContainerNo: "iWMSコンテナ番号",
        HiddenTable: "フォームを非表示",
        logisticsid: "配送伝票番号",
        RemoveCartonFromContainer: "コンテナからカートンを取り出す",
        RelID: "注文番号",
        PackID: "梱包ID",
        Carton: "カートン#",
        SKUQty: "商品数量",
        NewPallet: "新しいパレット",
        PalletNo: "パレット番号",
        WeightPallet: "パレット重量",
        Length: "長さ",
        InputaNumber: "数字を入力してください",
        Width: "幅",
        Height: "高さ",
        CBM: "体積",
        Weight: "重量",
        WeightUOM: "重量単位",
        LoadedPalletQty: "積載済みパレット数量",
        RemovePalletfromContainer: "コンテナからパレットを削除してください",
        Remarks: "備考",
        Desc: "詳細",
        SKU: "商品",
        LogicalWH: "論理倉庫",
        LotID: "ロットID",
        AvailableQty: "利用可能数量",
        AdjustQty: "調整数量",
        ReasonCode: "調整理由",
        Action: "加算または減算",
        Adjust: "調整",
        NotEnoughInventoryToAdjust: "調整するのに十分な在庫がありません",
        ActionCannotBeEmpty: "加算または減算は空にできません",
        ToLocationCannotBeEmpty: "目標ロケーションは空にできません",
        ToSkuCannotBeEmpty: "目標商品は空にできません",
        NotEnoughInventoryToMove: "移動するのに十分な在庫がありません",
        DataNotChange: "データが変更されていません。保存する必要はありません。",
        DataModifyNotSave: "変更されたデータは保存されていません",
        BatchUpdateShipment: "出荷の一括更新",
        BathUpdate: "一括更新",
        BatchUpdate: "一括更新",
        ButtonConfig: "ボタン設定",
        ButtonConfigName: "ボタン設定名",
        BePrint: "印刷",
        ActionValue: "アクション値",
        DeAllocation: "割り当て解除",
        BatchNo: "生産ロット番号",
        Qty: "数量",
        originalLotId: "元ロットID",
        soLineSeq: "注文行シーケンス",
        PickLineSeq: "ピッキング行シーケンス",
        ModifyTime: "変更時間",
        ShipOutDate: "出荷日",
        GenerateLocation: "ロケーション生成",
        RowName: "行名",
        ColumnInRow: "行の列",
        LevelInRow: "行のレベル",
        BinsinLocation: "ロケーションのビン",
        CartonToContainer: "カートンからコンテナへ",
        CartonToPallet: "カートンからパレットへ",
        PalletToContainer: "パレットからコンテナへ",
        Error: "エラー",
        Lookup: "検索",
        PrePrintLPN: "LPNを事前印刷",
        NumberOfLPNLabelRequired: "LPNラベル番号は必須です",
        Print: "印刷",
        ReprintLPN: "LPNを再印刷",
        Lpn: "LPN",
        Reprint: "再印刷",
        LastPrinted: "最終印刷",
        MoveLogic: "移動ロジック",
        Reason: "理由",
        FromLocation: "元ロケーション",
        MoveQty: "移動数量",
        ColumnName: "列名",
        printReportColumn: "レポート列を印刷",
        ScanIn: "入庫スキャン",
        RecID: "注文番号",
        CartonID: "カートンID",
        TraceID: "トレースID",
        ContainerId: "コンテナ",
        CartonIdNum: "カートン番号",
        DeleteCartonID: "カートンIDを削除",
        CartonIdQty: "カートンID数量",
        CartonIdNumRegExp: "カートン番号の正規表現エラー",
        CartonIdNumFormatError: "エラーカートン番号# {0} 、再スキャンしてください",
        ContainerIdIsEmpty: "コンテナは必須です",
        EPC: "EPC",
        EPCIsEmpty: "EPCは必須です",
        EPCFormatError:"偽造防止コードに異常があります。再度認識してください。",
        EpcQtyMustBeOne:"偽造防止コードは1個ずつスキャンしてください",
        SSCCIsEmpty: "SSCCは必須です",
        cartonTypeIsEmpty: "カートンタイプは必須です",
        ConvertToReceive: "受領に変換",
        CancelGR: "GRをキャンセル",
        NewGR: "新規GR",
        Descr: "説明",
        ASNQty: "ASN数量",
        OutstandingQty: "未スキャン数量",
        ContainerIdQty: "コンテナ数量",
        ScanAction: "スキャンアクション",
        RemoveSku: "削除",
        addSku: "追加",
        StockStatus: "在庫ステータス",
        LockScanQty: "スキャン数量をロック",
        LockContainer: "コンテナを削除",
        NoofSKU: "SKU数",
        NoofCartonID: "カートンID数",
        UOM: "単位",
        ScanPack: "スキャン梱包",
        WaveID: "波次ID",
        CancelPack: "梱包キャンセル",
        PrintPackingList: "梱包リストを印刷",
        PackingList: "梱包リストを印刷",
        AllocatedQty: "割り当て済み数量",
        PackedQty: "梱包済み数量",
        PackedQty2: "梱包済み数量",
        RemoveScanItem: "スキャンアイテムを削除",
        IsCarton: "カートンスキャン",
        ScanInDirectly: "直接スキャン",
        IsPrePack: "事前梱包",
        IsTraceId: "トレースID",
        UnpackQty: "未梱包数量",
        Detail: "詳細",
        Percentage: "パーセンテージ",
        NoofCarton: "カートン数",
        Createdby: "作成者",
        CloseAndNew: "閉じて新規作成",
        New: "新規",
        Remove: "削除",
        Append: "追加",
        ImportScanningFile: "スキャンファイルをインポート",
        ImportSacnningFileGroupName: "スキャンファイルをインポート",
        PrintSSCC: "SSCCを印刷",
        PrintCarton: "カートンを印刷",
        CartonNoSSCC: "カートン番号/SSCC",
        ScannedQty: "スキャン数量",
        CartonNo: "カートン番号",
        CartonType: "カートンタイプ",
        DimUOM: "寸法単位",
        GrossWeight: "総重量",
        NetWeight: "正味重量",
        PleaseNewOneCartonFirst: "まずカートンを1つ作成してください",
        Nosscc: "SSCCがありません。スキャンに必要なSSCCを入力してください",
        CancelTransit: "輸送をキャンセル",
        Transit: "輸送",
        Step: "ステップ",
        FromQty: "元数量",
        ToQty: "目標数量",
        ToSku: "目標SKU",
        FromSku: "元SKU",
        CourierEdi: "運送会社EDI",
        IntersoftGenerateLabel: "Intersoftラベル生成",
        IntersoftCancelLabel: "Intersoftラベルキャンセル",
        IntersoftGenerateMainfest: "Intersoftマニフェスト生成",
        exportPackageData: "梱包データをエクスポート",
        orderCheckCompleteStartTime: "注文確認完了開始時間",
        orderCheckCompleteEndTime: "注文確認完了終了時間",
        whetherToPrintOnlyCompletedOrders: "完了した注文のみを印刷するかどうか",
        addSoToWave: "注文を波次に追加",
        waveId: "波次ID",
        ref01: "参照コード01",
        ref02: "参照コード02",
        ref03: "参照コード03",
        ref04: "参照コード04",
        ref05: "参照コード05",
        query: "検索",
        reset: "リセット",
        save: "保存",
        gift: "贈答品",
        notGiftScanAntiCode: "贈答品ではありません。偽造防止コードをスキャンする必要があります。",
        searchCartonByWave: "波次でカートンを検索",
        importSscc: "SSCCをインポート",
        pleaseScanAntiCode: "偽造防止コードをスキャンしてください"

    },
    manual: {
        Manual: "手動",
        New: "新規",
        AddToPick: "ピッキングに追加",
        Unpick: "ピッキングをキャンセル",
        SO: "注文番号",
        Sku: "商品",
        RecID: "注文番号",
        BatchNo: "ロット番号",
        SODate: "注文日",
        AllQty: "割り当て数量/注文数量",
        AllocateLocation: "割り当てロケーション",
        Status: "ステータス",
        LotID: "ロットID",
        RecDate: "受領日",
        RecQty: "受領数量",
        AvailableQty: "利用可能数量",
        AllocateQty: "割り当て数量",
        ShippedQty: "出荷数量",
        MANUFACTUREDate: "製造日",
        EXPIRYDate: "有効期限",
        SHELFDate: "棚入れ日",
        NewpickPleasego: "新しいピッキングリストを作成して続行してください"

    },
    login: {
        SignAccount: "既存のアカウントでログイン",
        loginTitle1: "おかえりなさい",
        loginTitle2: "アカウントにログインしてください",
        loginTitle3: "2段階認証",
        loginTitle4: "この追加のステップは、現在ログインしているアカウントがあなたのものであることを証明します",
        loginTitle5: "以下の電話番号で認証コードを受信します：**** **",
        loginTitle6: "",
        loginTitle7: "支払いが必要です",
        loginTitle8: "通常の通信料",
        loginTitle9: "メールで認証コードを受信",
        loginTitle10: "認証コード",
        loginTitle11: "認証コードを入力してください",
        loginTitle12: "このブラウザを信頼しますか？",
        loginTitle13: "ウェブサイトにログインするには引き続きパスワードが必要ですが、次回ログイン時には認証コードの入力は求められません。（今後",
        loginTitle27: "日間）",
        loginTitle14: "GoogleまたはMicrosoft Authenticator",
        loginTitle15: "などのアプリで認証コードを取得",
        loginTitle16: "設定",
        loginTitle17: "設定をキャンセル",
        loginTitle18: "選択したTOTPをインストール",
        loginTitle19: "（時間ベースワンタイムパスワード）認証アプリ",
        loginTitle20: "QRコードをスキャン",
        loginTitle21: "または",
        loginTitle22: "「シークレットキー」をあなたの",
        loginTitle23: "認証アプリに入力",
        loginTitle24: "設定を完了",
        loginTitle25: "シークレットキー",
        loginTitle26: "シークレットキーが間違っています",
        Verify: "認証",
        PleaseUsername: "ユーザー名を入力してください！",
        Username: "ユーザー名", // user name
        Password: "パスワード",
        language: "言語",
        PleasePassword: "パスワードを入力してください！",
        ForgotPassword: "パスワードを忘れた場合",
        KeepIn: "ログイン状態を維持",
        SignIn: "ログイン",
        Or: "または",
        RegisterNewAccount: "新しいアカウントを登録",
        NeedHelpContactAdmin: "ヘルプが必要ですか？システム管理者にお問い合わせください",
        DonHaveAccount: "アカウントをお持ちではありませんか？",
        SignUPnow: "登録",
        UserPasswordError: "ユーザー名またはパスワードが間違っています",
        Cancel: "キャンセル",
        Create: "作成",
        EmailAddress: "メールアドレス",
        VerificationCode: "認証コード",
        Pleaseverification: "認証コードを入力してください",
        Sendverification: "認証コードを送信",
        NewPassword: "新しいパスワード",
        passWordError1: "パスワードの長さは8〜64文字です。",
        passWordError2: "",
        passWordError3: "- 小文字1つ",
        passWordError4: "- 大文字1つ",
        passWordError5: "- 数字1つ",
        passWordError6: "- 記号1つ",
        ConfirmNewPassword: "新しいパスワードを確認",
        PleaseConfirmPassword: "パスワードを確認",
        TwopasswordsInconsistent: "2回入力したパスワードが一致しません！",
        RegistrationSuccess: "登録成功", // 登録成功
        VerificationAddress: "認証コードを送信するをクリックしてください",
        Submit: "送信",
        NoUserExists: "ユーザーが存在しません",
        CaptchaError: "認証コードが間違っています",
        CaptchaVerified: "認証成功",
        emailError: "メールアドレスが無効です。",
        authenticationFailure: "認証失敗",
        SsoAccountMismatch: "Microsoftアカウントが入力したアカウントと一致しません。もう一度お試しください。",
        OldPassword: "古いパスワード",
        NewpasswordNotoldPassword: "新しいパスワードは古いパスワードと同じにできません",
        OriginalPasswordError: "古いパスワードが間違っています！",
        ResetPassword: "パスワードを変更",
        firstLoginChangePassword: "初回ログインでパスワードを変更してください",
        registerForm: "登録フォーム",
        UserAlreadyExist: "ユーザーは既に存在します！",
        ResetAliasName: "エイリアス名を変更",
        ChangeAliasName: "エイリアス名を変更",
        dashboardPortal:"ダッシュボード ポータル",
        signOut:"サインアウト",
        view:"表示",
        previous:"前へ",
        noReportIsSetupForThisAccount:"このアカウントにはレポートが設定されていません",
        PasswordExpiryWarning: "パスワード期限切れ警告",
        PasswordExpiryMessage: "パスワードの有効期限が近づいています。",
        PasswordExpiredToday: "パスワードは本日期限切れです！",
        PasswordExpiryDaysLeft: "パスワードは {days} 日後に期限切れになります。",
        PleaseChangePasswordImmediately: "アカウントロックを避けるため、すぐにパスワードを変更してください。",

    },
    batchReceive: {
        BatchReceive: "一括受領",
        Query: "検索",
        Accept: "受入",
        All: "すべて",
        Received: "受領済み",
        NotReceive: "未受領",
        ReceiveLocation: "受領ロケーション",
        EnterWordsQuery: "4文字以上入力して検索してください",
        EXPQty: "予定数量",
        RCVQty: "受領数量",
        RCVQtyEA: "受領数量 EA",
        TOID: "TOID",
        RCVLOC: "受領ロケーション",
        EXPIRYDATE: "有効期限",
        Descr: "説明",
        SKU: "商品",
        UDF1: "UDF1",
        UDF2: "UDF2",
        UDF3: "UDF3",
        ReceiveRequired: "受領ロケーションは必須です",
        RCVQtyCheck: "受領数量は0より大きい必要があります。",
        RCVQtyGtExpQty: "受領数量は予定数量より大きくすることはできません。",
        Status: "ステータス",
        Line: "行番号",
        RecDate: "受領日",
        LocationCode: "ロケーションコード",
        RecQty: "受領数量",
        RecBaseQty: "受領数量",
        DamageQty: "破損数量",
        DamageBaseQty: "破損数量",
        HoldQty: "保留数量",
        HoldBaseQty: "保留数量",
        Remarks: "備考",
        Desc: "詳細",
        ProductType: "製品タイプ",
        ASNQty: "ASN数量",
        ASNBaseQty: "ASN数量",
        UOM: "単位",
        PackageQty: "梱包数量",
        ManufactureDate: "製造日",
        ExpiryDate: "有効期限",
        ShelfDate: "棚入れ日",
        PalletID: "パレットID",
        CartonID: "カートンID",
        TraceID: "追跡ID",
        Article: "品目",
        NotAllowToOverReceive: "過剰受領は許可されていません。"

    },


    reportSetting: {
        DevName: "Dev Name",
        ReSQL: "Re-generate SQL",
        ColumnDetail: "Column Detail",
        ReportType: "Report Type",
        ReportVersion: "Report Version",
        EnglishName: "English Name",
        SimplifiedCNName: "Simplified CN Name",
        TraditionalCNName: "Traditional CN Name",
        EnglishTipsName: "English Tips Name",
        SimplifiedCNTipsName: "Simplified CN Tips Name",
        TraditionalCNTipsName: "Traditional CN Tips Name",
        DisplaySeq: "Display Seq",
        CalculateType: "Calculate Type",
        CustCode: "Cust Code",
        CustName: "Cust Name",
        ProjectCode: "Project Code",
        ProjectName: "Project Name",
        Beautify: "Beautify",
        Verify: "Verify",
        Generate: "Generate",
        Version: "Version",
        Assign: "分配",
        AssignName: "分配人",
        CopyFromMaster: "Copy from Master",
        plInpuSku: "Please input SKU",
        BatchSave: "Batch Save",
        SelectAllforSearchable: "Select All for Search",
        SelectAllforDisaplyable: "Select All for Display",
        importTemplate: "Import Template",
        Upload: "上传",
        Clone: "克隆",
        importConfig: "配置",
        importColumn: "标题字段",
        Mapping: "映射字段",
        Uniquekey: "是否唯一",
        DefaultType: "默认类型",
        DataType: "数据类型",
        Datalength: "数据长度",
        
        DecimalalPlace: "保留小数位",
        DateTimeFormat: "时间格式",
        StartPosition:"开始位置",
        EndPosition:"结束位置",
        Delimiter:"分隔符",
        ReferenceKey:"Reference Key",
        RangeValue:"范围值",
        DefaultValue: "默认值",
        Mandatory: "是否必填",
        CombineFields: "复制字段",
        UploadConfig : "上传配置",
        FileType:"文件类型",
        Delimilter: "Delimilter",
        DelimiterDesc:"默认为“/”, “null” 没有分割符,“Blank” 空格",
        CloneTemplate: "克隆模板",
        TableColumn: "表 字段",
        OperationRule: "操作模式",
        withHeader: "含标题行",
        excelStartRow:"数据起始行",
        isPrintReport:"打印报表",
        printReportCode:"打印报表编号",
      },

    soPage:{
        PackedFirst:"印刷は許可されていません，まず梱包してください!",
        inputAllQty:"割当数量を入力してください!",
        labelCreateDhlShipmentId: "新規作成 DHL Shipment ID",
        labelAddOrderToShipmentId: "オーダーの追加 Shipment ID",
        labelShipmentReference: "Shipment Reference",
        labelConfirm: "確認",
        labelQuery:"查询",
        msgShipmentReferenceIsNull: "Shipment Reference 空にすることはできません",
    },





    job:{
        Name: "ジョブ名",
        Class: "ジョブ対応クラス",
        Remark: "備考",
        Type: "ジョブタイプ",
        ParamName: "パラメータ名",
        ParamValue: "パラメータ値",
        Seq: "シーケンス番号",
        Add: "新規追加",
        Save: "保存",
        Run: "実行",
        Delete: "削除",
        Reset: "リセット",
        Query: "検索",
        Total: "合計",
        Records: "件のレコード",
        notNull: "空にできません！",
        Activate: "有効化",
        Inactivate: "無効化",
        Action: "アクション",
        Status: "ステータス",
        Expression: "式",
        BusinessType: "業務システムタイプ",
        StartTime: "開始時間",
        ActionNo: "アクション番号",
        CreateExpression: "式を生成",
        DateTime: "日付形式",
        Year: "年",
        Month: "月",
        Day: "日",
        Hour: "時",
        Minute: "分",
        Second: "秒",
        StatusCanNotDel: "有効なステータスは削除できません！",
        ExpressionNotCorrect: "式が正しくありません！",
        TriggerStatus: "トリガーステータス",
        PrevFireTime: "前回実行時間",
        NextFireTime: "次回実行時間"

    },
    wine: {
        AvailableQty: "入力数量が有効在庫数量を超えています！",
        inputEnglish: "英語のみ入力できます",
        inputChinese: "中国語のみ入力できます",
        maxCharacters: "最大{0}文字",
        mustInputChinese: "英語の住所が入力されていない場合、中国語の住所は必須です。"

    },
    printLabel:{
        NumberOfQrCodeLabelRequired: "Number of QR Code Label Required",
        NumberOfRelIdLabelRequired: "Number of Rel Id Label Required",
        labelType:"Label Type",
        qrCodeLabel:"Pre-Print Label",
    },
    cfs:{
        OrderCancel: "注文インターセプト",
        operationSuccess: "操作成功",
        orderNo: "注文番号",
        loadingNo: "梱包リスト番号",
        platformOrderNo: "プラットフォーム注文番号",
        parcelNo: "バーコード",
        unScanQty: "未スキャン数量",
        invoiceFlag: "ラベル/インボイス印刷フラグ",
        scannedQty: "スキャン済み数量",
        parcelNoTrackingNo: "小包番号/追跡番号（最終配送ラベル）",
        trackingNo: "追跡番号（最終配送ラベル）",
        destinationCountry: "仕向国",
        courier: "クーリエ",
        parcelNotOrder: "小包はこの注文に属していません",
        printLabel: "ラベルを印刷",
        printDhlInvoice: "DHLコマーシャルインボイスを印刷",
        scanLoad: "梱包をスキャン",
        awbMbl: "AWB / MBL / 追跡番号",
        uldNo: "コンテナ番号 / ULD番号",
        collectionTimeFrom: "集荷時間（開始）",
        collectionTimeTo: "集荷時間（終了）",
        createLoading: "梱包リストを作成",
        confirmLoading: "梱包確認",
        ediSendFlag: "EDI送信フラグ",
        resetFirst: "まずリセットしてください。",
        noOfDestinationLabelRequired: "仕向けラベルの必要枚数",
        orderNumber: "伝票番号",
        barcode: "バーコード",
        damage: "破損",
        dimensions: "寸法",
        nextOrder: "次の注文",
        delete: "削除",
        printViewPdf: "箱ラベルを印刷"

    },
    support:{
        org:"Org",
        project:"Project Name",
        a01ReopenASNAsn:"ASN#",
        note:"Note",
        submit:"Submit",
        reset:"Reset",
        c01MovePOToWarehousePO:"PO#",
    },
    printerConfig: {
        refresh: "プリンターリストを更新",
        servicesName: "サーバー名",
        ip: "IPアドレス",
        printerName: "プリンター名"

    },
    scanPack:{
        cancelCheckCompleteMsg: 'すべての梱包済みカートンを削除しますか？',
        cancelCheckCompleteMoveMsg: 'キャンセルされたすべての在庫を元の場所に戻しますか？',
        cancelCheckCompleteNo: 'いいえ',
        cancelCheckCompleteYes: 'はい',
        title: '確認',
        currentScanQty: '現在のスキャン数量',
        deletePickingData: "ピッキングデータを削除しますか？",
        firstCancelCheckCompleteThenScanPack: "現在の注文には一部のチェックが完了しています。チェック完了をキャンセルしますか？",
        antiCounterfeitingCodePleaseConfirm: "非出荷偽造防止コードです。確認してください。",
        currentBrand: "現在のブランド",
        getExpressNumber: "宅配便番号を取得",
        ssccAlreadyUse: "SSCC#{0} は混合梱包注文を許可しません",
        scanByWave: "波次ID ( {0} ) を使用してスキャンしてください",
        notAllowedBatchClose: "現在、梱包データが提出されていません。バッチでの梱包終了は許可されていません"

    },
    skuSearch:{
        skuSearch: "SKU検索",
        upcSearch: "UPC検索",
        sku: "SKUコード",
        multipleSku: "一括SKUコード",
        skuFrom: "開始SKUコード",
        skuTo: "終了SKUコード",
        search: "検索",
        skuCode: "SKUコード",
        skuDesc: "SKU説明",
        upc: "商品バーコード",
        style: "スタイル",
        color: "色",
        size: "サイズ"

    },
    invTrans:{
        transType: "トランザクションタイプ",
        transStatus: "トランザクションステータス",
        orderNo: "伝票番号",
        transTimeFrom: "トランザクション時間（開始）",
        transTimeTo: "トランザクション時間（終了）",
        systemUser: "システムユーザー",
        lotAttribute: "ロット属性",
        ownerCode: "荷主",
        lotNo: "ロット番号",
        id: "追跡番号",
        back: "戻る",
        transId: "トランザクション番号",
        transTime: "トランザクション時間",
        lineNo: "行番号",
        transactionTime: "トランザクションログ時間照会は{0}日以内の照会である必要があります！",
        operator: "操作者",
        ownerCodeFrom: "荷主（開始）",
        ownerCodeTo: "荷主（終了）",
        skuFrom: "商品（開始）",
        skuTo: "商品（終了）",
        skuDescFrom: "商品名（開始）",
        skuDescTo: "商品名（終了）",
        lotNoFrom: "ロット番号（開始）",
        lotNoTo: "ロット番号（終了）",
        idFrom: "追跡番号（開始）",
        idTo: "追跡番号（終了）",
        locFrom: "ロケーション（開始）",
        locTo: "ロケーション（終了）",
        qtyFrom: "数量（開始）",
        qtyTo: "数量（終了）",
        unitQtyFrom: "単位数量（開始）",
        unitQtyTo: "単位数量（終了）",
        uomFrom: "単位（開始）",
        uomTo: "単位（終了）",
        descriptionFrom: "説明（開始）",
        descriptionTo: "説明（終了）",
        amount: "金額",
        typeMustBeSelected: "操作タイプを選択する必要があります",
        pleaseSelectAQueryPeriod: "照会期間を選択してください"

    },
    currency:{
        currency: "通貨",
        description: "説明",
        currencySymbol: "通貨記号"

    },
    billingMaintance: {
        add: "新規追加",
        query: "検索",
        reset: "リセット",
        edit: "編集",
        billId: "請求書番号",
        cutOffFrom: "締め切り時間",
        billingPeriodFrom: "請求期間開始",
        billingPeriodTo: "請求期間終了",
        confirmDate: "確認日",
        postDate: "発行日",
        invoiceNo: "請求書番号",
        invoiceDate: "請求書日付",
        billToName: "請求先名",
        billToAddress1: "請求先住所1",
        billToAddress2: "請求先住所2",
        billToAddress3: "請求先住所3",
        billToAddress4: "請求先住所4",
        ToCity: "請求先市",
        billToProvince: "請求先省",
        billToCountry: "請求先国",
        billToZip: "請求先郵便番号",
        ToContactName: "請求先担当者名",
        billToContactPhone: "請求先連絡先電話番号",
        billToContactFax: "請求先FAX",
        billToContactEmail: "請求先メールアドレス",
        currency: "通貨",
        exchangeRate: "為替レート",
        lineNo: "行番号",
        chargeMethod: "請求方法",
        tariffId: "関税ID",
        chargeCode: "料金コード",
        description: "説明",
        billDateFrom: "請求日（開始）",
        billDateTo: "請求日（終了）",
        billType: "請求タイプ",
        billBase: "請求ベース",
        billUnit: "請求単位",
        overflowCharge: "超過料金",
        accountCode: "勘定科目コード",
        localExchangeRate: "現地為替レート",
        baseAmount: "基本金額",
        localAmount: "現地金額",
        totalAmount: "合計金額",
        invoiceLineSeq: "請求書明細行番号",
        CreateMaintance: "作成",
        EditMaintance: "編集",
        PleaseinputBillId: "請求書番号を入力してください",
        msgBillingPeriodFromLessThanTo: "請求開始時間は請求終了時間より小さい必要があります"


    },
    resPlan:{
        workingDayOnly: "稼働日のみ適用",
        waveIdNotnull: "波次番号は必須です",
        needCreateResourcePlan: "リソース計画を作成する必要がありますか？"

    },
    cycleCount:{
        Location: "ロケーション番号",
        createTicket: "チケット作成",
        includeStatus: "ステータスを含む",
        reCount: "再カウント",
        numberOfSplit: "分割回数",
        confirmToCreateTicketForLocation: "棚卸記録以外のロケーションを含め、以下のロケーションの棚卸を開始または再開することを確認しますか？",
        confirmToReCountLocation: "ロケーションを再カウントすることを確認しますか？"

    },
    handheldConfiguration:{
        handheldConfiguration: "ハンディターミナル設定",
        handheldApplicationConfiguration: "ハンディターミナルアプリケーション設定",
        configName: "設定名",
        relatedFunction: "関連機能",
        status: "ステータス",
        flowSetting: "フロー設定",
        orderSearch: "注文検索",
        scanning: "スキャン",
        haveSearchScreen: "検索画面を表示しますか？",
        scanName: "スキャン名",
        promptMessage: "プロンプトメッセージ",
        actionSettings: "アクション設定",
        action: "アクション",
        targetField: "ターゲットフィールド",
        field: "フィールド",
        stepSettings: "ステップ設定",
        new: "新規",
        value: "値",
        type: "タイプ",
        length: "長さ",
        dataLength: "データ長",
        relatedSettings: "関連設定",
        lockValue: "値をロックしますか？",
        displayIn: "表示場所",
        showCurrProgress: "現在の進捗を表示",
        showSummary: "概要を表示",
        info: "情報",
        showConfDialog: "設定ダイアログを表示",
        displayText: "表示テキスト",
        changeCommand: "コマンド変更",
        last: "(最新)",
        completeOnCloseNext: "閉じる/次へで完了しますか？",
        suggestLocation: "ロケーションを提案しますか？",
        dialogSettings: "ダイアログ設定",
        input: "入力",
        mandatory: "必須",
        dimension: "必須", // dimensionとmandatoryが同じ意味で使われているため、重複を避けるために同じ翻訳にしています
        volume: "容積",
        grossWeight: "総重量",
        netWeight: "正味重量",
        logicSettings: "ロジック設定",
        use: "使用",
        priority: "優先度",
        lastLocation: "最新ロケーション",
        nextEmptyLocation: "次の空ロケーション",
        pickLocation: "ピッキングロケーション",
        storageLocation: "保管ロケーション",
        closeToSameSku: "同じSKUに閉じる",
        matchItemType: "同じタイプを一致させる",
        useProjectLocation: "プロジェクトロケーションを使用",
        useWarehouseLocation: "倉庫ロケーションを使用",
        scanSingle: "単一行スキャン？",
        displayInformation: "情報表示",
        scanningScanNameCannotBeEmpty: "スキャン {0} のスキャン名は空にできません。",
        orderSearchScanNameCannotBeEmpty: "注文検索のスキャン名は空にできません。"

    },
    cycleCountMaster:{
        belowLocationAndSku: "以下のロケーションとSKUには割り当て数量/保有数量があります。これらを無視して棚卸オーダーを作成してもよろしいですか？",
        quantityNeedsToBeGreaterThan0: "数量は0より大きい必要があります",
        createCountOrderByNumber: "デフォルトのカウント回数で棚卸オーダーを作成しますか？",
        countOrderCompleteOrder: "棚卸 {0} および関連するチケットはまだ処理中です。\n未処理の取引をクローズして棚卸を完了しますか？"

    },
    confirmDeleteLoading: "オーダーはすでに積載されています。積載リストから削除してもよろしいですか？",
    expDeliveryDateNotnull: "予定出荷日は空にできません！",
    scanIn: "受領スキャン",
    carrier: "運送業者",
    flightNo: "便名",
    parcelUnWeighed: "小包は未計量",
    airLine: "航空会社",
    arrivedTime: "到着時間",
    shipFrom: "発送元",
    shipTime: "出発時間",
    services: "サービス",
    servicesProvider: "サービスプロバイダー",
    gatewayCannotBeEmpty: "ゲートウェイは空にできません",
    serviceCannotBeEmpty: "サービスは空にできません",
    serviceProviderCannotBeEmpty: "サービスプロバイダーは空にできません",
    skynetPostal: "郵便チャネル",
    battery: "バッテリー",
    batteryCannotBeEmpty: "バッテリーは空にできません",
    copyLoading: "積載リストをコピー",
    showAll: "すべて表示",
    processActionMsg: "この操作を確認しますか？",
    orderRef: "注文番号",
    printNotConnected: "プリンター接続失敗",
    notLabelRecord: "レコードが見つかりません",

    collarBarcode:{
        woolenCollarBarcode: "ファーカラーバーコード",
        woolenCollarBarcodeMismatch: "ファーカラーバーコードが一致しません",
        missing: "不足"

    },
    soStatus:{
        partialAllocated: "部分割り当て済み",
        allocation: "割り当て",
        partialPicked: "部分ピッキング済み",
        picked: "ピッキング済み",
        partialPacked: "部分梱包済み",
        packed: "梱包済み",
        partialLoaded: "部分積載済み",
        loaded: "積載済み",
        partialShipped: "部分出荷済み",
        shipped: "出荷済み",
        delivered: "配送済み",
        billed: "請求済み",
        cancelled: "注文キャンセル",
        deleted: "削除済み",
        closed: "注文完了"

    },
    asnStatus:{
        partialReceived: "部分受領済み",
        received: "受領済み",
        partialPutaway: "部分棚入れ済み",
        putaway: "棚入れ済み",
        cancelled: "キャンセル済み",
        deleted: "削除済み",
        closed: "クローズ済み"

    },
    loading:{
        loadId: "積載ID",
        container: "積載番号",
        hidden: "非表示",
        searchCartonByWave: "波次でカートンを検索",
        importSscc: "SSCCをインポート",
        seal: "封印番号",
        containerType: "積載タイプ",
        vesselFight: "船舶",
        voyage: "航海",
        mbl: "MBL",
        hbl: "HBL",
        driver: "ドライバー",
        etd: "出発予定時刻",
        eta: "到着予定時刻",
        portOfLoading: "積載港",
        portOfDischarge: "荷揚げ港",
        portOfDestination: "目的港",
        loadFrom: "積載開始時間",
        loadTo: "積載終了時間",
        remarks: "備考",
        loadedCartonQty: "積載済みカートン数量",
        detailSearch: "詳細検索"

    },
    filterBy: "フィルター",
    allocationResults: "割り当て結果",
    importResults: "インポート結果",
    lastestNotifications: "最新の{0}件の通知",
    todayNotifications: "今日の通知",
    yesterdayNotifications: "昨日の通知",
    success: "成功",
    failed: "失敗",
    inputNumCharsThenPressEnter: "{0}文字以上入力してEnterを押してください",
    queryCondition:"検索条件",
    thaiName:"タイ語名",
    japaneseName:"日本語名",
    headerJoinFieldName:"ヘッダー結合フィールド名",
    detailJoinFieldName:"詳細結合フィールド名",
    queryFieldName:"検索フィールド名",
    compareType:"比較タイプ",
    fixedValue:"固定値",
    pageType:"コントロールタイプ",
    codeMasterGroup:"マスターコードグループ",
    queryTable:"フィールド所属テーブル",
    headerTable:"ヘッダー結合テーブル",
    detailTable:"詳細結合テーブル",
    stdBalanceReport: {
        brand: "ブランド",
        size: "サイズ",
        volume: "個体体積",
        totalVolume: "総体積",
        department: "部門",
        sku: "商品",
        skuName: "品名",
        material: "材料品番/コード",
        specification: "仕様",
        units: "単位",
        qty: "数量",
        inboundTime: "最終入庫時間",
        outboundTime: "最終出庫時間",
        period: "期間",
        remark: "備考/説明",
        Location: "保管場所",
        prePicture: "画像プレビュー"
    },
    // ログインモーダル多言語
    sessionModal: {
        title: "ログインが期限切れです",
        message: "長時間操作がないため、再度ログインしてください",
        passwordChangedMessage: "パスワードが変更されました。再度ログインしてください",
        username: "ユーザー名",
        password: "パスワード",
        loginButton: "ログイン",
        logoutButton: "ログアウト",
        usernameRequired: "ユーザー名とパスワードを入力してください",
        passwordRequired: "パスワードを入力してください",
        loginFailed: "ログインに失敗しました。ユーザー名とパスワードを確認してください",
        loginError: "ログインに失敗しました。再試行してください",
        loginSuccess: "再ログインが成功しました",
        loginLoading: "ログイン中...",
        loginTimeout: "リクエストがタイムアウトしました。再試行してください",
        securityTitle: "セキュリティ警告",
        securityMessage: "不正なデータ変更が検出されました。セキュリティのため再度ログインしてください",
        securityWarning: "セキュリティのため、身元を確認してください",
        tokenExpiredMessage: "セッションの有効期限が切れました。再度ログインしてください",
        tokenInvalidMessage: "認証トークンが無効です。再度ログインしてください",
        noPermissionTitle: "権限なし",
        noPermissionMessage: "このリソースにアクセスする権限がありません",
        okButton: "OK",
        projectChangedTitle: "プロジェクトが変更されました",
        projectChangedMessage: "現在のプロジェクトが変更されました。正しいプロジェクトデータを読み込むため、ページを更新してください。",
        reloadButton: "ページを更新",
        reloginButton: "再ログイン"
    },
    projectQueryList:"プロジェクト検索リスト",
    defaultQueryList:"デフォルト検索リスト",
    hide:"隠す",
    show:"表示する",
    copyToProjectList:"プロジェクトリストにコピー",
    copyToAnotherLanguage:"他の言語にコピー",
    copyToAnotherProject:"他のプロジェクトにコピー",
    copyTo:"~ にコピーする",
    DueDateUpdateConfirm:"以下のウェーブにはスキャンパッケージの締切日が含まれています。更新を確認しますか？",
    domain:"ドメイン",
    singleSignOn:"シングルサインオン",
}